import Colors from '../../../../../utils/colors';
import ExampleExpander from '../../../../users/advance-search/compoenents/expander';
import { Tag } from 'primereact/tag';
import { SalariesActivityTypeTable } from '../../componenets/salaries-activity-type-table';
import React from 'react';
import { SalariesColumnSummeryItem } from '../../componenets/salaries-column-summery-item';
import {
  PendingPaymentBranch,
  PendingPaymentCourse,
} from '../../../../../api/types/accountants/salaries-pending-payments/salaries-pending-payments.type';
import { toast } from 'react-toastify';
import { CourseStatus } from '../../../../../api/types/programs/course/course-status';
import { LecturerRateDisplayType } from '../../../../../api/types/lecturers/price-rate/lecturer-rate-display-type';

interface SalariesBranchExpanderProps {
  branchId: string;
  branchName: string;
  // Branch level summaries
  branchTotalHours: string;
  branchRate: string;
  branchTotalToPay: string;
  // Activity type level summaries
  activityType: string;
  activityTotalHours: string;
  activityRate: string;
  activityTotalPaid: string;
  activityTotalToPay: string;
  pendingPaymentBranch: PendingPaymentBranch;
}

export const SalariesBranchExpander: React.FC<SalariesBranchExpanderProps> = ({
  branchId,
  branchName,
  branchTotalHours,
  branchRate,
  branchTotalToPay,
  activityType,
  activityTotalHours,
  activityRate,
  activityTotalPaid,
  activityTotalToPay,
  pendingPaymentBranch,
}) => {
  const asd = (courseItem: PendingPaymentCourse) => {
    let sum = 0;
    courseItem.rates.forEach((item) => {
      //
      let hoursNumber = 0;
      item.workingHours.forEach((workingHoursItem) => {
        const hours =
          (new Date(workingHoursItem.endTime).getTime() -
            new Date(workingHoursItem.startTime).getTime()) /
          (1000 * 60 * 60);

        hoursNumber = hoursNumber + hours;
      });

      sum +=
        hoursNumber *
        item.rate *
        (item.displayType === LecturerRateDisplayType.OneHour ? 1 : 4 / 3);
    });

    return sum.toFixed(2).toString();
  };

  return (
    <ExampleExpander>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: '36px',
        }}
      >
        <label style={{ color: '#4338ca' }}>{branchName}</label>
        <SalariesColumnSummeryItem
          text={'סה״כ שעות'}
          value={branchTotalHours}
          valueStyle={{ color: Colors.warningText }}
        />
        <SalariesColumnSummeryItem
          text={'סה״כ לתשלום'}
          value={branchTotalToPay}
          valueStyle={{ color: Colors.warningText }}
        />
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        <label style={{ fontSize: '12px', color: '#807e7e' }}>
          * להלן רשימת הקורסים בהם בוצעה פעילות המרצה
        </label>

        {pendingPaymentBranch.courses.map((courseItem) => (
          <ExampleExpander key={courseItem.courseId}>
            <div
              style={{
                width: '100%',
                paddingLeft: '8px',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: '36px',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  gap: '36px',
                }}
              >
                <SalariesColumnSummeryItem
                  text={'קורס'}
                  value={courseItem.courseName}
                  valueStyle={{ color: Colors.warningText }}
                />
                <SalariesColumnSummeryItem
                  text={'סטטוס קורס'}
                  value={CourseStatus.getDisplayText(courseItem.status)}
                  valueStyle={{ color: Colors.warningText }}
                />
                <SalariesColumnSummeryItem
                  text={'מכסת שעות'}
                  value={courseItem.courseHours.toString()}
                  valueStyle={{ color: Colors.warningText }}
                />

                <SalariesColumnSummeryItem
                  text={'סה״כ שעות בפועל'}
                  value={courseItem.totalHours.toString()}
                  valueStyle={{ color: Colors.warningText }}
                />

                <SalariesColumnSummeryItem
                  text={'סה״כ לתשלום'}
                  value={asd(courseItem)}
                  valueStyle={{ color: Colors.warningText }}
                />
              </div>
              <Tag value={'טרם שולם'} severity={'danger'} />
            </div>
            <SalariesActivityTypeTable
              pendingPaymentCourse={courseItem}
              branchId={parseInt(branchId)}
            />
          </ExampleExpander>
        ))}
      </div>
    </ExampleExpander>
  );
};
